import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorCreateStore } from "../../store";
import { WorkAuthorCreateForm } from "./WorkAuthorCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type WorkAuthorCreateProps = {
  workAuthorCreateStore: WorkAuthorCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const WorkAuthorCreate: React.FC<WorkAuthorCreateProps> = observer(
  ({ workAuthorCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={workAuthorCreateStore.isSaving} />
        <WorkAuthorCreateForm
          workAuthorCreateStore={workAuthorCreateStore}
          authorError={workAuthorCreateStore.errors.author?.message}
          onAuthorChange={(value) => {
            workAuthorCreateStore.setAuthorValue(value);
          }}
          authorSelectedValue={workAuthorCreateStore.entityValues.showAuthor}
          onAuthorSelected={(value) => {
            workAuthorCreateStore.setSelectedAuthor(value);
          }}
          authorOptions={workAuthorCreateStore.getAuthorOptions()}
          lyricsPercentageError={
            workAuthorCreateStore.errors.lyricsPercentage?.message
          }
          onLyricsPercentageChange={(value: number) => {
            workAuthorCreateStore.setLyricsPercentageValue(value);
          }}
          lyricsPercentage={workAuthorCreateStore.entityValues.lyricsPercentage}
          musicPercentageError={
            workAuthorCreateStore.errors.musicPercentage?.message
          }
          onMusicPercentageChange={(value: number) => {
            workAuthorCreateStore.setMusicPercentageValue(value);
          }}
          musicPercentage={workAuthorCreateStore.entityValues.musicPercentage}
          workAuthorPublisherCreateStore={
            workAuthorCreateStore.publishersCreateStore
          }
          publishersVisibleColumns={
            workAuthorCreateStore.publishersVisibleColumns
          }
          publishersOnRestore={(id: string) =>
            workAuthorCreateStore.publishersRestore(id)
          }
          publishersOnCommitChanges={(changes) =>
            workAuthorCreateStore.publishersCommitChanges(changes)
          }
          publishersValidateChanges={(changes) =>
            workAuthorCreateStore.publishersValidateChanges(changes)
          }
          publishersRows={workAuthorCreateStore.entityValues.showPublishers}
          publishersError={workAuthorCreateStore.errors.publishers?.message}
          dummyCRUDRestoredObservable={
            workAuthorCreateStore.dummyCRUDRestoredObservable
          }
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={workAuthorCreateStore.isProcessing}
          onSave={() => workAuthorCreateStore.saveNewWorkAuthor()}
          onCancel={() => workAuthorCreateStore.cancelNewWorkAuthor()}
          viewFormAuthor={() => workAuthorCreateStore.viewFormAuthor()}
        />
        <ErrorDialog
          open={workAuthorCreateStore.errorDialogOpened}
          title={workAuthorCreateStore.errorTitle}
          description={workAuthorCreateStore.errorDescription}
          onClose={() => workAuthorCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
